<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.fornecedores.editar.titulo")',
        :voltarPara='{ route: "ConfiguracaoFornecedores" }'
    )
    .bloco-cadastro-fornecedores
        h3 {{ $t('mensagens.fornecedores.editar.tituloInformacoesCadastrais') }}
        .form-cadastro-fornecedor
            .form-cadastro-fornecedor__row
                label.form-cadastro-fornecedor__row-label.obrigatorio {{ $t('mensagens.fornecedores.editar.campoNome') }}
                input.form-cadastro-fornecedor__row-input(
                    placeholder='Descreva o nome',
                    v-model='fornecedor.nome',
                    disabled
                )
            .form-cadastro-fornecedor__row
                label.form-cadastro-fornecedor__row-label {{ $t('mensagens.fornecedores.editar.campoIDSAP') }}
                input.form-cadastro-fornecedor__row-input(
                    placeholder='Descreva o ID ERP',
                    v-model='fornecedor.idSap'
                )
            .form-cadastro-fornecedor__row
                label.form-cadastro-fornecedor__row-label.obrigatorio {{ $t('mensagens.fornecedores.editar.campoCPFouCNPJ') }}
                .form-cadastro-fornecedor__row-input-area(
                    v-for='(cpfCnpj, index) in fornecedor.cpfsCnpjs'
                )
                    input.form-cadastro-fornecedor__row-input(
                        v-mask='["###.###.###-##", "XX.XXX.XXX/XXXX-##"]',
                        placeholder='Insira um CPF ou CNPJ válido',
                        v-model='cpfCnpj.valor',
                        :key='index'
                    )
                    .form-cadastro-fornecedor__btn-remover-cpf-cnpj(
                        @click='removerCpfCnpj(index)'
                    )
                        i.el-icon-delete
                .form-cadastro-fornecedor__btn-add-cpf-cnpj(
                    @click='adicionarCpfCnpj'
                )
                    i.el-icon-plus
                    span {{ $t('mensagens.fornecedores.editar.botaoAdicionarCPFCNPJ') }}
        .footer
            .footer__btn.voltar(@click='goToListagemFornecedores')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(@click='editarFornecedor')
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import validators from '@/utils/validators';
import formatters from '@/utils/formatters';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';

export default {
    name: 'EditarFornecedor',
    props: ['row'],
    components: {
        BaseHeader
    },
    data() {
        return {
            fornecedor: {
                nome: this.row.nome,
                idSap: this.row.idSap,
                cpfsCnpjs: [{ valor: '' }]
            }
        };
    },
    mounted() {
        this.montarCnpjCpf();
    },

    methods: {
        montarCnpjCpf() {
            this.fornecedor.cpfsCnpjs = this.row.cpfsCnpjs.map(cpfCnpj => ({
                valor: cpfCnpj
            }));
        },
        adicionarCpfCnpj() {
            const ultimoCpfCnpj = this.fornecedor.cpfsCnpjs.at(-1)?.valor;
            const cnpjCpfValido =
                ultimoCpfCnpj && validators.validarCpfCnpj(ultimoCpfCnpj);

            if (cnpjCpfValido || this.fornecedor.cpfsCnpjs.length === 0) {
                this.fornecedor.cpfsCnpjs.push({ valor: '' });
            } else {
                this.$notify.error(
                    'Insira um CPF ou CNPJ válido para seguir adicionando'
                );
            }
        },
        removerCpfCnpj(index) {
            this.fornecedor.cpfsCnpjs.splice(index, 1);
        },
        goToListagemFornecedores() {
            this.$router.push({ name: 'ConfiguracaoFornecedores' });
        },
        async editarFornecedor() {
            const inputValido = this.validaInput();
            if (inputValido) {
                try {
                    const payload = this.montarPayload();
                    const { data } =
                        await ContratoOriginacaoService.editarFornecedor(
                            payload
                        );
                    this.$notify.success(data);
                    this.$router.push({ name: 'ConfiguracaoFornecedores' });
                } catch (error) {}
            }
        },
        validaInput() {
            if (!this.fornecedor.nome || this.fornecedor.nome.trim() === '') {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.fornecedores.editar.erroNomeFornecedor'
                    )
                });
                return false;
            }

            const setCpfCnpj = new Set(
                this.fornecedor.cpfsCnpjs.map(cpfCnpj => cpfCnpj)
            );

            if (setCpfCnpj.size !== this.fornecedor.cpfsCnpjs.length) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.fornecedores.editar.erroCPFCNPJDuplicado'
                    )
                });
                return false;
            }

            return true;
        },
        montarPayload() {
            const cpfsCnpjs = this.fornecedor.cpfsCnpjs
                .map(cpfCnpj =>
                    formatters.cpfCnpjFormatToNumeral(cpfCnpj.valor)
                )
                .filter(cpfCnpj => cpfCnpj);

            return {
                nome: this.fornecedor.nome,
                idSap: this.fornecedor.idSap,
                cpfsCnpjs
            };
        }
    }
};
</script>

<style lang="scss">
.bloco-cadastro-fornecedores {
    margin: 20px;
}

.form-cadastro-fornecedor {
    margin-top: 10px;
    background-color: $white;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: $default-border-radius;
    @include default-box-shadow();
}

.form-cadastro-fornecedor__row {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.form-cadastro-fornecedor__row-label {
    color: $primary;
    font-weight: bold;
}

.obrigatorio::after {
    content: '* ';
    color: red;
    margin-left: 3px;
}

.form-cadastro-fornecedor__row-input {
    width: 50%;
    height: 40px;
    border-radius: $default-border-radius;
    border: 1px solid $default-border-color;
    outline: 0;
    padding: 0 15px;
}

.form-cadastro-fornecedor__row-input-area {
    display: flex;
    gap: 10px;
    align-items: center;
}

.form-cadastro-fornecedor__btn-remover-cpf-cnpj {
    width: 48px;
    height: 32px;
    background-color: $background-danger;
    color: $font-danger;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $default-border-radius;
}

.form-cadastro-fornecedor__btn-add-cpf-cnpj {
    width: 210px;
    height: 40px;
    margin-top: 5px;
    background-color: $white;
    color: $primary;
    font-weight: bold;
    border: 1px solid $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    border-radius: $default-border-radius;
    cursor: pointer;

    i.el-icon-plus {
        font-weight: bold;
    }
}

.form-cadastro-fornecedor__btn-add-cpf-cnpj:hover {
    background-color: var(--primary);
    color: $white;
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
